<template>
    <div>
        <div class="header">
            {{ $vuetify.lang.t('$vuetify.timeTableSetting.timeTableSetting') }}
        </div>
        <nav-bar
            ref="navbar"
            @menu-change="menuChange"
            :menuItem="navbarList">
        </nav-bar>

        <component :is="component" />
    </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import GroupNormalWorkday from '@/components/TimeTableSetting/GroupNormalWorkday.vue'
import LeaveQuota from '@/components/TimeTableSetting/LeaveQuota.vue'
import SpecialWorkday from '@/components/TimeTableSetting/SpecialWorkday.vue'
import GroupHoliday from '@/components/TimeTableSetting/GroupHoliday.vue'
import permissionConstant from '@/constants/permissions.js'

export default {
    name: 'TimeTableSetting',

    components: {
        NavBar,
        GroupNormalWorkday,
        GroupHoliday,
        SpecialWorkday,
        LeaveQuota
    },
    computed: {
        menuItem () {
            return [
                {
                    title: this.$vuetify.lang.t('$vuetify.timeTableSetting.workday'),
                    path: 'GroupNormalWorkday',
                    pathName: 'group-workday',
                    permission: [permissionConstant.groupWorkday.view]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.timeTableSetting.specialWorkday'),
                    path: 'SpecialWorkday',
                    pathName: 'special-workday',
                    permission: [permissionConstant.specialWorkday.view]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.timeTableSetting.groupHoliday'),
                    path: 'GroupHoliday',
                    pathName: 'group-holiday',
                    permission: [permissionConstant.groupHoliday.view]
                }
            ]
        },
        navbarList () {
            const navbar = []
            for (let i = 0; i < this.menuItem.length; i++) {
                const show = this.menuItem[i].permission.some(p => this.userPermissions.includes(p))
                if (show) {
                    navbar.push(this.menuItem[i])
                }
            }
            return navbar
        }
    },
    data () {
        return {
            component: 'GroupNormalWorkday',
            userPermissions: []
        }
    },

    methods: {
        menuChange (payload) {
            this.component = payload.path

            const path = `/time-table-setting/${this.navbarList[payload.index].pathName}`
            if (this.$route.path !== path) {
                this.$router.replace(path)
            }
        },

        navbarPermission () {
            // for (let i = 0; i < this.menuItem.length; i++) {
            //     const show = this.menuItem[i].permission.some(p => this.userPermissions.includes(p))
            //     if (show) {
            //         this.navbarList.push(this.menuItem[i])
            //     }
            // }

            this.component = this.navbarList[0].path
        },

        setActive (path) {
            let index = 0
            if (path === 'TimeTableSetting') {
                this.$refs.navbar.go(this.navbarList[0].pathName, index)
            } else {
                index = this.navbarList.findIndex(x => x.path === path)
                this.$refs.navbar.go(path, index)
            }

            const directPath = `/time-table-setting/${this.navbarList[index].pathName}`
            if (this.$route.path !== directPath) {
                this.$router.replace(directPath)
            }
        }
    },

    mounted () {
        this.userPermissions = this.$store.state.permissions
        this.navbarPermission()
        this.setActive(this.$router.currentRoute.name)
    }
}
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
}
</style>
